const data = {
  ADD_TODO_ITEM: 'ADD_TODO_ITEM',
  REMOVE_TODO_ITEM: 'REMOVE_TODO_ITEM',
  TOGGLE_COMPLETED: 'TOGGLE_COMPLETED'
}

export default data
